import { formatOdds, formatPoint, formatTotalPoint } from "./odds";
import {
  calcRiskFromWin,
  calcWinFromRisk,
  roundMoney,
} from "../components/lib/wagerFinancials";

export const callBetMarketLabel = (oddType) => {
  if (oddType === "h2h") return "M-Line";
  if (oddType === "totals") return "Total";
  if (oddType === "spreads") return "Spread";
  return oddType || "Pick";
};

export const getCallBetBookPoint = (item) => {
  if (item?.bookPoint != null && item.bookPoint !== "") {
    const n = Number(item.bookPoint);
    if (Number.isFinite(n)) return n;
  }
  if (item?.originalPoint != null && item.originalPoint !== "") {
    const n = Number(item.originalPoint);
    if (Number.isFinite(n)) return n;
  }
  if (!item?.isCallBetMode && item?.betstatus !== "NotActivated") {
    const n = Number(item?.point);
    return Number.isFinite(n) ? n : null;
  }
  return null;
};

export const getCallBetBookPrice = (item) => {
  if (item?.bookPrice != null && item.bookPrice !== "") {
    const n = Number(item.bookPrice);
    if (Number.isFinite(n)) return n;
  }
  if (item?.originalPrice != null && item.originalPrice !== "") {
    const n = Number(item.originalPrice);
    if (Number.isFinite(n)) return n;
  }
  const n = Number(item?.price);
  return Number.isFinite(n) ? n : null;
};

export const getCallBetDesiredPoint = (item) => {
  const raw =
    item?.customizedPoint ??
    item?.desiredPoint ??
    (item?.betstatus === "NotActivated" || item?.isCallBetMode
      ? item?.point
      : null);
  if (raw === undefined || raw === null || raw === "") return null;
  const n = Number(raw);
  return Number.isFinite(n) ? n : null;
};

export const getCallBetDesiredPrice = (item) => {
  const raw =
    item?.desiredPrice ??
    (item?.oddType === "h2h" || item?.type === "h2h"
      ? item?.price
      : null);
  const n = Number(raw);
  return Number.isFinite(n) ? n : null;
};

/** Book line at placement — spread/total show line @ price; ML shows price only. */
export const formatCallBetBookLine = (item) => {
  if (!item) return "-";
  if (item.type === "h2h" || item.oddType === "h2h") {
    const price = getCallBetBookPrice(item);
    return price == null ? "-" : formatOdds(price);
  }
  const point = getCallBetBookPoint(item);
  const price = getCallBetBookPrice(item);
  if (point == null) return "-";
  const line =
    item.type === "totals" || item.oddType === "totals"
      ? formatTotalPoint(point, item.pointType || item.teamName)
      : formatPoint(point);
  return price == null ? line : `${line} @ ${formatOdds(price)}`;
};

/** User's limit-order target. */
export const formatCallBetDesiredLine = (item) => {
  if (!item) return "-";
  if (item.type === "h2h" || item.oddType === "h2h") {
    const price = getCallBetDesiredPrice(item);
    return price == null ? "-" : formatOdds(price);
  }
  const point = getCallBetDesiredPoint(item);
  if (point == null) return "-";
  if (item.type === "totals" || item.oddType === "totals") {
    return formatTotalPoint(point, item.pointType || item.teamName);
  }
  return formatPoint(point);
};

export const formatCallBetComparison = (item) => {
  const book = formatCallBetBookLine(item);
  const desired = formatCallBetDesiredLine(item);
  if (book === "-" || desired === "-" || book === desired) return null;
  return { book, desired };
};

/**
 * Odds used for call-bet risk/win/payout preview and submit.
 * M-Line: desired price when entered; spreads/totals: book juice (line is separate).
 */
export const resolveCallBetPriceForPayout = (item) => {
  if (!item) return null;

  const isH2h = item.type === "h2h" || item.oddType === "h2h";
  if (isH2h) {
    const raw = item.desiredPrice;
    if (raw !== undefined && raw !== null && String(raw).trim() !== "") {
      const desired = Number(raw);
      if (Number.isFinite(desired)) return desired;
    }
  }

  const book = getCallBetBookPrice(item);
  if (book != null) return book;

  const fallback = Number(item.price);
  return Number.isFinite(fallback) ? fallback : null;
};

/** Recompute win/payout when desired M-Line price changes but risk/win is already set. */
export const recalculateCallBetPayout = (item) => {
  if (!item) return item;

  const price = resolveCallBetPriceForPayout(item);
  if (!Number.isFinite(price)) return item;

  const risk = Number(item.risk);
  const win = Number(item.win);

  if (risk > 0) {
    const nextWin = calcWinFromRisk(risk, price);
    return {
      ...item,
      win: nextWin,
      payout: roundMoney(risk + nextWin),
      Price: item.Price ?? risk,
    };
  }

  if (win > 0) {
    const nextRisk = calcRiskFromWin(win, price);
    return {
      ...item,
      risk: nextRisk,
      Price: nextRisk,
      payout: roundMoney(nextRisk + win),
    };
  }

  return item;
}; 
